import fulfilmentImg from '@/assets/img/home/Fulfilment.png';

/**
 * "Fulfillment Services & Subcontractor Management" marketing block — faithful
 * port of the legacy reipm `components/home/Fulfilment.tsx` (next/image →
 * plain `img`, next/link → anchor; colors kept as the legacy raw hex values).
 */
export const Fulfilment = () => {
  return (
    <div className="flex justify-center pt-24">
      <div className="w-full max-w-[1314px] pb-14 lg:pb-20">
        <div className="flex flex-col items-center md:flex-row md:items-start">
          <div className="relative order-2 w-full text-left md:order-1 md:w-1/2">
            <h2 className="mx-3 mb-4 text-[32px] leading-[35px] font-bold text-[#0061E5] md:mx-0 lg:text-[40px] lg:leading-[45px]">
              Fulfillment Services & Subcontractor Management
            </h2>
            <p className="mx-3 mb-6 max-w-[571px] font-light text-[#0A1524] md:mx-0">
              Managing multiple subcontractors, tracking service completion, and ensuring accurate billing are major
              challenges in fulfillment. GPM provides real-time tracking and financial transparency to streamline every
              stage.
            </p>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://gpmgis.com/fulfilment"
              className="mx-3 inline-flex items-center rounded-[12px] bg-[#0061E5] px-6 py-3 text-[#F9FBFF] transition hover:bg-[#0061E5] md:mx-0"
            >
              Check the Use Case
              <span className="ml-2.5">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M22.8673 12.7942C22.5688 12.7942 22.2826 12.9128 22.0715 13.1239C21.8605 13.3349 21.7419 13.6211 21.7419 13.9196V18.4496C21.7409 19.3246 21.3929 20.1634 20.7742 20.7821C20.1556 21.4008 19.3167 21.7488 18.4418 21.7498H5.55083C4.67589 21.7488 3.83707 21.4008 3.21839 20.7821C2.59972 20.1634 2.25171 19.3246 2.25072 18.4496V5.55865C2.25171 4.68371 2.59972 3.84489 3.21839 3.22621C3.83707 2.60753 4.67589 2.25953 5.55083 2.25853H10.0809C10.3793 2.25853 10.6656 2.13997 10.8766 1.92892C11.0877 1.71788 11.2062 1.43164 11.2062 1.13317C11.2062 0.834709 11.0877 0.548469 10.8766 0.337423C10.6656 0.126377 10.3793 0.0078125 10.0809 0.0078125H5.55083C4.07919 0.00954983 2.66833 0.594927 1.62772 1.63553C0.587113 2.67614 0.00173733 4.08701 0 5.55865V18.4496C0.00173733 19.9213 0.587113 21.3322 1.62772 22.3728C2.66833 23.4134 4.07919 23.9988 5.55083 24.0005H18.4418C19.9134 23.9988 21.3243 23.4134 22.3649 22.3728C23.4055 21.3322 23.9909 19.9213 23.9926 18.4496V13.9196C23.9926 13.6211 23.8741 13.3349 23.663 13.1239C23.452 12.9128 23.1657 12.7942 22.8673 12.7942Z"
                    fill="#F9FBFF"
                  />
                  <path
                    d="M22.8436 9.50817e-08H15.8476C15.5529 -5.6417e-05 15.27 0.115478 15.0596 0.321781C14.8491 0.528084 14.728 0.808694 14.7223 1.10332C14.7105 1.73493 15.2418 2.25072 15.8729 2.25072H20.1554L11.1929 11.2161C10.9818 11.4271 10.8633 11.7134 10.8633 12.0118C10.8633 12.3103 10.9818 12.5965 11.1929 12.8075C11.4039 13.0186 11.6901 13.1371 11.9886 13.1371C12.287 13.1371 12.5733 13.0186 12.7843 12.8075L21.7497 3.84498V8.14292C21.7497 8.44138 21.8682 8.72762 22.0793 8.93867C22.2903 9.14971 22.5766 9.26828 22.875 9.26828C23.1735 9.26828 23.4597 9.14971 23.6708 8.93867C23.8818 8.72762 24.0004 8.44138 24.0004 8.14292V1.15631C24.0004 1.00442 23.9705 0.85402 23.9123 0.7137C23.8542 0.573379 23.769 0.445888 23.6615 0.338509C23.5541 0.23113 23.4266 0.145966 23.2862 0.0878842C23.1459 0.0298018 22.9955 -6.14978e-05 22.8436 9.50817e-08Z"
                    fill="#F9FBFF"
                  />
                </svg>
              </span>
            </a>
          </div>
          <div className="relative order-1 mb-6 w-full md:order-2 md:mb-0 md:w-1/2">
            <img width={1466} height={824} src={fulfilmentImg} alt="Fulfilment" className="h-auto w-full" />
          </div>
        </div>
      </div>
    </div>
  );
};
